import styled from 'styled-components';
import { fonts } from 'styles';
import imageHeader from 'assets/images/header.jpg';

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: #402314;
  color: #f1dabd;
  text-align: left;
  column-gap: 88px;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    height: auto;
    color: #000000;
    text-align: center;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;

export const ImageHeader = styled.img.attrs({ src: imageHeader })`
  height: 100vh;
  object-fit: contain;

  @media screen and (max-width: 1280px) {
    width: 100%;
    height: auto;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 540px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    max-width: 100%;
    align-items: center;
    background-color: #ffffff;
    padding: 64px 40px;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 55px;
  line-height: 69px;
  letter-spacing: -0.05em;
  text-transform: uppercase;
  margin-bottom: 24px;

  @media screen and (max-width: 500px) {
    font-size: 36px;
    line-height: 38px;
    letter-spacing: -0.06em;
  }
`;

export const Subtitle = styled.article`
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 48px;

  @media screen and (max-width: 500px) {
    font-size: 23px;
    line-height: 28px;
    margin-bottom: 24px;
  }
`;

export const Credit = styled.div`
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  line-height: 22px;
`;
